module.exports = __webpack_public_path__ + "img/1-4.f391fc07.jpg";